import { API_URL } from '../config/api';

// Интерфейсы для данных стилей обложек
export interface CoverStyle {
  id: string;
  userId: string;
  name: string;
  prompt: string;
  negativePrompt?: string;
  modelStyle?: string;
  imageBase64?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateCoverStyleRequest {
  name: string;
  prompt: string;
  negativePrompt?: string;
  modelStyle?: string;
  imageBase64?: string;
}

export interface UpdateCoverStyleRequest {
  id: string;
  name: string;
  prompt: string;
  negativePrompt?: string;
  modelStyle?: string;
  imageBase64?: string;
}

// Базовый метод для API-запросов
const api = {
  get: async (endpoint: string) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  post: async (endpoint: string, data: any) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  put: async (endpoint: string, data: any) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  delete: async (endpoint: string) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.status === 204 ? true : response.json();
  }
};

// Сервис для работы со стилями обложек
export const coverStyleService = {
  /**
   * Получить все стили пользователя
   */
  getUserStyles: async (): Promise<CoverStyle[]> => {
    return api.get('/cover-styles');
  },

  /**
   * Получить стиль по идентификатору
   */
  getStyleById: async (id: string): Promise<CoverStyle> => {
    return api.get(`/cover-styles/${id}`);
  },

  /**
   * Создать новый стиль
   */
  createStyle: async (data: CreateCoverStyleRequest): Promise<CoverStyle> => {
    return api.post('/cover-styles', data);
  },

  /**
   * Обновить существующий стиль
   */
  updateStyle: async (data: UpdateCoverStyleRequest): Promise<CoverStyle> => {
    return api.put(`/cover-styles/${data.id}`, data);
  },

  /**
   * Удалить стиль
   */
  deleteStyle: async (id: string): Promise<boolean> => {
    return api.delete(`/cover-styles/${id}`);
  },

  /**
   * Конвертировать файл изображения в строку base64
   */
  fileToBase64: async (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  },

  /**
   * Загрузить изображение и преобразовать в base64
   */
  uploadImage: async (file: File): Promise<string> => {
    try {
      return await coverStyleService.fileToBase64(file);
    } catch (error) {
      console.error('Ошибка загрузки изображения:', error);
      throw new Error('Не удалось загрузить изображение');
    }
  }
}; 